import { render, staticRenderFns } from "./LumberManagement.vue?vue&type=template&id=5adbc48e&scoped=true"
import script from "./LumberManagement.vue?vue&type=script&lang=js"
export * from "./LumberManagement.vue?vue&type=script&lang=js"
import style0 from "./LumberManagement.vue?vue&type=style&index=0&id=5adbc48e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adbc48e",
  null
  
)

export default component.exports